import { render } from "./legoGridColumn.vue?vue&type=template&id=c4e28ad8"
import script from "./legoGridColumn.vue?vue&type=script&lang=js"
export * from "./legoGridColumn.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/lego-component/components/layout/legoGrid/legoGridColumn.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "c4e28ad8"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('c4e28ad8', __exports__)) {
    api.reload('c4e28ad8', __exports__)
  }
  
  module.hot.accept("./legoGridColumn.vue?vue&type=template&id=c4e28ad8", () => {
    api.rerender('c4e28ad8', render)
  })

}


export default __exports__